export default __webpack_public_path__ + "static/media/FinalDesign.4ac8bc1c.png";